import React from 'react';
import { SparklesIcon, PlusIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PageHeader() {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between pb-6 border-b border-border mb-8" data-id="element-123">
      <div data-id="element-124">
        <h1 className="text-3xl font-bold tracking-tight text-foreground" data-id="element-125">
          Ready-Made Templates
        </h1>
        <p className="text-muted-foreground mt-1" data-id="element-126">
          Pick a design and start building in minutes. No experience needed!
        </p>
      </div>
      <div className="flex items-center gap-3 mt-4 sm:mt-0" data-id="element-127">
        <Button variant="outline" className="gap-2 bg-background hover:bg-muted" data-id="element-128">
          <SparklesIcon className="w-4 h-4" data-id="element-129" />
          Create With AI
        </Button>
        <Button className="gap-2 bg-[#f97316] hover:bg-[#ea580c] text-white border-none shadow-sm" data-id="element-130">
          <PlusIcon className="w-4 h-4" data-id="element-131" />
          Start From Scratch
        </Button>
      </div>
    </div>;
}